import {
  Component,
  EnvironmentInjector,
  OnInit,
  ChangeDetectorRef,
  SimpleChange,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  runInInjectionContext,
} from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { LoginService } from "../../Services/login.service";
import { config, pageSizeOption } from "../../config";
import { Observable, Observer, Subscription } from "rxjs";
import { map, startWith } from "rxjs/operators";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import moment from "moment";
import * as _ from "lodash";
import { TooltipPosition } from "@angular/material/tooltip";
import { element } from "protractor";
import { timeStamp } from "console";
import {
  AngularFireDatabase,
  AngularFireList,
} from "@angular/fire/compat/database";
import { ProjectService } from "src/app/Services/project.service";
import { MatSnackBar } from "@angular/material/snack-bar";
import { DisplayToastComponent } from "src/app/DisplayToast/display-toast/display-toast.component";
import { SharedService } from "src/app/Services/sharedService";
import { MessagingServiceService } from "src/app/Services/messaging-service.service";
import { MatPaginator } from "@angular/material/paginator";
import { DatePipe, ViewportScroller } from "@angular/common";
import { HttpClient } from "@angular/common/http";
import swal from 'sweetalert2';
import { SweetAlertService } from "src/app/Services/sweet-alert.service";
import JSZip from "jszip";
import { saveAs } from 'file-saver';
import { TokenEncryptionService } from "src/app/Services/token-encryption.service";
import { ScreenshotTimeService } from "src/app/Services/screenshot-time.service";
import { ScreenshotFancyboxService } from "src/app/Services/screenshot-fancybox.service";
import { DateTime } from "luxon";
class User {
  id: string;
  email: string;
  ssRequest: boolean;
  scRequestStart: boolean;
  scRequestStop: boolean;
  status: string;
  time: string;
  isreceive: boolean;
}
@Component({
  selector: "app-screen-shot-viwer",
  templateUrl: "./screen-shot-viwer.component.html",
  styleUrls: ["./screen-shot-viwer.component.css"],
  providers: [DatePipe],
  standalone: false
})
export class ScreenShotViwerComponent implements OnInit {

  @ViewChild("EmpPaginator", { static: false }) EmpPaginator: MatPaginator;

  userId;
  offset = 1;
  today = new Date();
  userSSList;
  totalSS = 0;
  userSSListDuplicate: any;
  filePath = config.baseMediaUrl;
  paginationArray = [];
  isAdmin: boolean = false
  user: any;
  p: number = 1;
  statusObservable: Subscription;
  userStatus: any;
  loading = false;
  @Output() childEvent = new EventEmitter();
  private dbPath: string | null = null;

  @Input("userDetails") userDetails;
  @Input("startDate") startDateFilter: any;
  @Input("endDate") endDateFilter: any;
  @Input("status") status: any;

  serverDate: any = new Date();
  requested: boolean = false;
  userList: any;
  durationInSeconds = 3;
  snackbarClass = "snackbarClass";
  usersRef: AngularFireList<User> = null;
  Status = "offline";
  filterOnData: any = [];
  screenShotDataList: any;
  showingErrorImage: any = false;
  timeAgo: true;
  startDate: any;
  endDate: any = new Date();
  userImageClass = 'avatar-img';
  userDataSubscription: Subscription;
  isDownloadAll: boolean;
  isDeleteAll: boolean;
  selectedImagesLength;
  allScreenShotsSelected = true
  minDate!: any;
  maxDate!: any;
  shiftTimezone: string | null = null;
  regionHint: string | null = null;
  pageOptions = pageSizeOption
  pageSize = this.pageOptions[0];


  constructor(
    private route: ActivatedRoute,
    private loginService: LoginService,
    private _projectService: ProjectService,
    private snackBar: MatSnackBar,
    private _change: ChangeDetectorRef,
    private db: AngularFireDatabase,
    private _sharedService: SharedService,
    private _messagingService: MessagingServiceService,
    private datePipe: DatePipe,
    private http: HttpClient,
    private sweetAlertService: SweetAlertService,
    private scroller: ViewportScroller,
    private tokenEncryptionService: TokenEncryptionService,
    private injector: EnvironmentInjector,
    private screenshotTime: ScreenshotTimeService,
    private screenshotFancybox: ScreenshotFancyboxService
  ) {
    // Initialize pageSize from localStorage
    const savedPageSize = localStorage.getItem('pageSize');
    if (savedPageSize && [25, 50, 100].includes(Number(savedPageSize))) {
      this.pageSize = Number(savedPageSize);
    }

    // Listen for dbPath updates
    this._projectService.isFirebaseRefresh.subscribe((newDbPath: any) => {
      if (newDbPath && newDbPath.data) {
        this.dbPath = newDbPath.data;
        console.log('ScreenShotViewer: dbPath updated to:', this.dbPath);
      }
    });

    this.dbPath = this.tokenEncryptionService.getEncryptedItem<string>('dbPath') as string;

    this.isAdmin = JSON.parse(localStorage.getItem('isAdmin')) || false
    _messagingService.showNotification();
    this.startDate = new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      new Date().getDate() - 7
    );
    const sub = this.route.params.subscribe((user) => {
      this.userId = user.userId;
    });
    this.getstatus();
  }

  ngOnChanges(changes: SimpleChange) {

    this.isAdmin = JSON.parse(localStorage.getItem('isAdmin')) || false

    let change: any = changes;

    if (change.endDateFilter) {

      if (this.startDateFilter !== null && this.endDateFilter !== null) {

      }
    }

    if (change.userDetails && change.userDetails.currentValue) {
      this.userId = change.userDetails.currentValue.id;
      this.user = change.userDetails.currentValue.name;
      this.getSSlistUser();
    }
  }

  onStartDateChange(event) {
    let date = event.value;
    this.startDate = date;
  }

  onEndDateChange(event) {
    let date = event.value;
    this.endDate = date;
    if (this.startDate && this.endDate) {
      this.pageSize = 25;
      this.offset = 1;
      if (this.EmpPaginator) {
        this.EmpPaginator.firstPage()
      }
      this.getSSlistUser();

    }
  }

  ngOnInit() {
    this.loggedInUserDetails();
    const companyId = this.tokenEncryptionService.getEncryptedItem<any>('logedInUser')?.company_id;
    this.screenshotTime.getShiftTimezoneForCompany(companyId).subscribe((tz) => {
      this.shiftTimezone = tz;
      this.regionHint = this.screenshotTime.getScreenshotsRegionHint(tz);
      if (this.userId) {
        this.getSSlistUser();
      }
    });
    this.getstatus()
    this.getUserList();
    this.getUserDetails();
    this.offset = this.EmpPaginator && this.EmpPaginator["_pageIndex"] ? this.EmpPaginator["_pageIndex"] + 1 : 1;
  }

  ngOnDestroy() {
    if (this.userDataSubscription) {
      this.userDataSubscription.unsubscribe();
    }
    this._messagingService.resetData()
  }

  getAll(): AngularFireList<User> {
    return this.usersRef;
  }

  getUserList() {
    this.loading = true;
    this._projectService.getUserList(0, 0).subscribe((user: any) => {
      this.userList = user;
      this.loading = false;
    });
  }

  getUserfromUserList(userInfo) {
    let selectedUser = this.userList.filter((ele: any) => {
      return ele.id == parseInt(userInfo);
    });
    return selectedUser[0];
  }

  getUserName(userId) {
    let selectedUser = this.userList.filter((ele: any) => {
      if (ele.id == parseInt(userId)) {
        return ele.name;
      }
    });
    return selectedUser[0].name;
  }

  getUserDetails() {
    this._projectService.getEmployeeData(this.userId).subscribe((data: any) => {
    });
  }

  getstatus() {
    // Ensure dbPath exists before proceeding
    if (!this.dbPath) {
      console.warn('ScreenShotViewer: dbPath not set, cannot initialize Firebase reference');
      return;
    }

    this.usersRef = runInInjectionContext(this.injector, () => this.db.list(this.dbPath));
    this.userDataSubscription = this._messagingService.getUserData().subscribe((users) => {
      users.forEach((user) => {
        if (user.id === this.userId) {
          this.Status = user.status === "online" ? "online" : "offline";
        }

        if (
          user.id === this.userId &&
          (this.offset === 0 || this.offset === 1) &&
          this.datePipe.transform(new Date(), "yyyy-MM-dd") === this.datePipe.transform(this.endDate, "yyyy-MM-dd")
        ) {
          this.processScreenshotData(user);
        }
      });
    });
  }

  processScreenshotData(user) {
    const screenshotTypes = [
      { key: "ssRequest", type: "admin-request" },
      { key: "ssPeriodic", type: "Periodic" },
      { key: "ssAppChanged", type: "app-changed" },
    ];

    screenshotTypes.forEach(({ key, type }) => {
      const screenshot = user[key];

      if (screenshot && !user.isreceive) {
        const rawT = screenshot.createdAt;
        const jsonData = {
          large: screenshot.largeImg || screenshot.imgURL,
          thumbnail: screenshot.imgURL,
          ist_time: rawT,
          captured_at: rawT,
          captured_time: rawT,
          timeDisplay: this.screenshotTime.getScreenshotTimeView(rawT, this.shiftTimezone),
          timeagoInput: this.screenshotTime.toTimeagoInput(rawT, this.shiftTimezone),
          showAbsoluteTime: this.screenshotTime.isCaptureOlderThanMinutes(String(rawT), this.shiftTimezone),
          user_id: user.id,
          type,
          app_name: screenshot.applicationName,
        };

        if (!this.userSSList.some((item) => JSON.stringify(item) === JSON.stringify(jsonData))) {
          this.userSSList.unshift(jsonData);
        }
      }
    });
  }

  getSSlistUser() {
    this.loading = true;
    const startM = moment(this.startDate).startOf('day');
    const endM = moment(this.endDate).endOf('day');
    const range = this.screenshotTime.filterBoundsForApi(startM, endM, this.shiftTimezone);
    this
      ._projectService
      .getSingleSS(this.userId,
        this.pageSize,
        this.offset,
        range.start,
        range.end)
      .subscribe(
        (res: any) => {

          this.userSSList = undefined;
          this.userSSList = [];
          if (res.length == 0) {
            this.loading = false;
            this.showingErrorImage = true;
          }
          let userData: any = res.body.data;
          for (let i = 0; i <= userData.length - 1; i++) {
            let imageData = userData[i];


            if (imageData['ist_time']) {
              imageData['captured_at'] = imageData['ist_time'];
            }

            imageData.timeAgo = this.screenshotTime.isWithinLast24Hours(imageData['ist_time'], this.shiftTimezone);

            imageData.captured_time = imageData.ist_time;
            imageData.captured_at = imageData.ist_time;
            imageData.timeDisplay = this.screenshotTime.getScreenshotTimeView(imageData.ist_time, this.shiftTimezone);
            imageData.timeagoInput = this.screenshotTime.toTimeagoInput(imageData.ist_time, this.shiftTimezone);
            imageData.showAbsoluteTime = this.screenshotTime.isCaptureOlderThanMinutes(imageData.ist_time, this.shiftTimezone);
            imageData.id = imageData.id;
            imageData.isSelected = true
            this.userSSList.push(imageData);
            this.filterOnData.push(imageData);
          }

          this.selectedImagesLength = this.userSSList.length
          this.loading = false;
          if (!this.userSSList.length) {
            this.loading = false;
            this.showingErrorImage = true;
          }
          this.requested = false;
          this.totalSS = res.headers.get('X-WP-Total');
        },
        (err) => {
          this.userSSList = [];
          this.loading = false;
          this.showingErrorImage = true;
        }
      );
  }
  displayUserName(id) {
    let resData = this.userList.filter((data: any) => {
      return data.id == id;
    });
    return resData.length ? resData[0].name : "";
  }
  compareDatetime(a, b) {
    return a.datetime - b.datetime;
  }

  getFileName(ss, index?) {
    // console.log("ss ======>", ss, index);
    if (ss && ss.path) ss = ss.path;
    let name = ss.split("/")[1];
    return `${name.split("-")[4]}:${name.split("-")[5]}  ${name.split("-")[1]
      }/${name.split("-")[2]}/${name.split("-")[3]}`;
  }

  getFileNameTime(ss) {
    if (ss && ss.path) ss = ss.path;
    let name = ss.split("/")[1];

    let date = `${name.split("-")[2]}/${name.split("-")[1]}/${name.split("-")[3]
      }`;

    let time = `${name.split("-")[4]}:${name.split("-")[5]}`;

    let timeStamp = new Date(`${date} ${time}`);

    return timeStamp;
  }

  requestScreenShot(userId) {
    if (!this._sharedService.canTriggerScreenshotRequest(userId)) {
      return;
    }
    let data = {
      appName: "Requesting Screenshot",
      name: this.user,
    };
    this._sharedService.showToast(data);
    this._sharedService.startOnDemandScreenshotRequest({
      employeeId: userId,
      dbPath: this.dbPath,
      source: 'screenshot_viewer',
    });
    this.requested = true;
  }

  removeSpecialSS() {
    if (this.userSSList[0].path) {
      let path = this.userSSList[0].path;
      this.userSSList.splice(0, 1);
      this.userSSList.unshift(path);
      const dup = JSON.parse(JSON.stringify(this.userSSList));
      this.userSSListDuplicate = dup;
    }
  }

  selectDate(event: any) {
    if (event.end) {
      const zone = this.shiftTimezone || 'Asia/Kolkata';
      let cursor = DateTime.fromJSDate(event.start._d).setZone(zone).startOf('day');
      const endDt = DateTime.fromJSDate(event.end._d).setZone(zone).endOf('day');
      const date: string[] = [];
      while (cursor <= endDt) {
        const ymd = cursor.toFormat('yyyy-MM-dd');
        const reverse = ymd.split('-').reverse().join('-');
        date.push(reverse);
        cursor = cursor.plus({ days: 1 });
      }
      this.filterScreenShot({ dateRange: date });
    }
  }

  filterScreenShot(params) {
    let filteredSS = [];
    _.forEach(this.userSSListDuplicate, (singleSS, ssIndex) => {
      _.forEach(params.dateRange, (singleDate, dateIndex) => {
        if (singleSS.includes(singleDate)) {
          filteredSS.push(singleSS);
        }
      });
    });

    this.userSSList = filteredSS;
    let i = 1;
    while (i <= Math.ceil(this.userSSList.length / 10)) {
      this.paginationArray.push(i);
      i++;
    }
  }

  clearDatePicker() {
    this.userSSList = this.userSSListDuplicate;
    let i = 1;
    while (i <= Math.ceil(this.userSSList.length / 10)) {
      this.paginationArray.push(i);
      i++;
    }
    $("#dateRangePicker").val(null);
  }

  onPageChange(event) {
    this.pageSize = event.pageSize;
    localStorage.setItem('pageSize', this.pageSize.toString());
    this.offset = event.pageIndex + 1;
    this.getSSlistUser();

    setTimeout(() => {
      this.scroller.scrollToAnchor('screenshotViewerSection');
    }, 0);
  }

  userName(event) {
    (event);
    this.user = event;
  }

  checkStatus(params) {
    if (params.user == this.userId && params.status) {
      this.userStatus = params.status;
    } else {
      this.userStatus = "offline";
    }
  }

  filterScreenShots(startDate: any, endDate: any) {
    let filteredData: any = [];
    const startDateTimestamp = new Date(startDate).getDate();
    const endDateTimestamp = new Date(endDate).getDate();
    filteredData = this.filterOnData.filter((ele) => {
      const capturedAtTimestamp = new Date(ele["captured_at"]).getDate();
      if (
        capturedAtTimestamp >= startDateTimestamp &&
        capturedAtTimestamp <= endDateTimestamp
      ) {
        return ele;
      }
    });
    return filteredData;
  }

  convertLowerCase(str) {
    return str.toLowerCase()
  }

  trimName(name) {
    const trimmedName = name.length <= 20 ? name : name.slice(0, 20) + (name.length > 20 ? '...' : '');
    return trimmedName;
  }

  onScreenshotCardClick(image: any): void {
    if (!this.userSSList?.length) {
      return;
    }
    const startIndex = Math.max(
      0,
      this.userSSList.findIndex((p: any) => p.id === image.id)
    );
    this.screenshotFancybox.open({
      items: this.userSSList,
      startIndex,
      userList: this.userList ?? [],
      showEmployee: false,
      showWindow: false,
      shiftTimezone: this.shiftTimezone,
    });
  }

  removeScreenShot(imageInfo) {
    const userName = this.getUserfromUserList(imageInfo.user_id)?.name || 'Unknown User';
    this.sweetAlertService
      .showScreenshotConfirmation(imageInfo, userName).then((result) => {
        if (result.isConfirmed) {
          const screenshotIds = imageInfo.id
          this._projectService.removeScreenshots(screenshotIds).subscribe((removed) => {
            this.sweetAlertService.showAlert('Screenshot deleted', 'The screenshot was permanently removed.', 'success')
            this.getSSlistUser()
          }, (error) => {
            console.error(" Can not remove the screenshot")
          })
        }
      });
  }

  downloadScreenShot(imageInfo) {
    console.log(imageInfo)
    const imageUrl = imageInfo.image_url;
    this.http.get(imageUrl + '?cacheblock=true', { responseType: 'blob' }).subscribe((blob) => {
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `${this.getUserfromUserList(imageInfo.user_id)?.name}_${imageInfo.captured_time}.png`; // Set the desired filename
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    });
  }

  enableSelection(status?: string) {
    if (status == 'download') {
      this.allScreenShotsSelected = true
      this.onSelectAllScreenshotsChange(this.allScreenShotsSelected)
      this.isDownloadAll = true
    }
    else if (status === 'delete') {
      this.allScreenShotsSelected = true
      this.onSelectAllScreenshotsChange(this.allScreenShotsSelected)
      this.isDeleteAll = true
    }
    else {
      this.isDownloadAll = false
      this.isDeleteAll = false
      this.onSelectAllScreenshotsChange(this.allScreenShotsSelected)
    }
  }

  downloadAll() {
    const urls = []
    const times = []
    swal.fire({
      title: 'Download in Progress',
      html: 'Please wait while your file is being downloaded...',
      allowOutsideClick: false, // Prevent closing by clicking outside
      showConfirmButton: false, // Hide the confirm button
      didOpen: () => {
        swal.showLoading(); // Show loading spinner
      }
    });
    this.userSSList.forEach((photo) => {
      if (photo.isSelected && photo?.large) {
        urls.push(photo.large)
        times.push(photo.captured_time)
      }
    })
    this.downloadFilesAsZip(urls, this.getUserName(this.userSSList[0].user_id), times)
  }

  downloadFilesAsZip(urls: string[], zipFileName: string, times: string[]): void {
    const zip = new JSZip();
    const folder = zip.folder(zipFileName);
    const filePromises = urls.map((url, index) => {
      return this.http.get(url + '?cacheblock=true', { responseType: 'blob' }).toPromise().then((blob) => {
        const fileName = `${times[index]}.${url.split('.').pop()}`;
        console.log(blob)
        folder?.file(fileName, blob);
      });
    });

    Promise.all(filePromises).then(() => {
      zip.generateAsync({ type: 'blob' }).then((zipFile) => {
        swal.close(); // Close the loading alert
        saveAs(zipFile, `${zipFileName}.zip`);
        this.enableSelection()
      });
    });
  }

  removeAllImages() {
    let screenShotIds = []

    this.userSSList.forEach(element => {
      if (element.isSelected) {
        screenShotIds.push(element.id)
      }
    });

    const totalImages = screenShotIds.length;

    this.sweetAlertService
      .showRemoveAllImagesConfirmation(totalImages)
      .then((result) => {
        if (result.isConfirmed) {
          const data = { "post_ids": screenShotIds }
          this._projectService.removeScreenshots(data).subscribe((removed) => {
            this.sweetAlertService.showAlert(
              totalImages === 1 ? 'Screenshot deleted' : 'Screenshots deleted',
              totalImages === 1
                ? 'The screenshot was permanently removed.'
                : `${totalImages} screenshots were permanently removed.`,
              'success'
            )
            this.enableSelection()
            this.getSSlistUser()
          }, (error) => {
            console.error(" Can not remove the screenshot")
          })
        } else {
          console.log('Image removal canceled.');
        }
      });
  }

  selectImage(image, index) {
    if (this.userSSList[index].isSelected) {
      this.userSSList[index].isSelected = false
      this.selectedImagesLength = this.selectedImagesLength - 1
    }
    else {
      this.userSSList[index].isSelected = true
      this.selectedImagesLength = this.selectedImagesLength + 1
    }
  }

  onSelectAllScreenshotsChange(value: boolean): void {
    console.log('All screenshots selected:', value);
    if (value) {
      this.userSSList.forEach(element => {
        element.isSelected = true
      });
      this.selectedImagesLength = this.userSSList.length
    }
    else {
      this.userSSList.forEach(element => {
        element.isSelected = false
      });
      this.selectedImagesLength = 0
    }

  }

  loggedInUserDetails() {
    this._projectService.getUser().subscribe((data: any) => {
      if (data && data?.meta) {
        this.serverDate = data?.meta?.today_date || new Date();
        const companyId = this.tokenEncryptionService.getEncryptedItem<any>('logedInUser')?.company_id ?? data?.company_id;
        this._sharedService.getValidationDateRangeByCompany(this.serverDate, companyId).subscribe((range) => {
          this.maxDate = range.maxDate;
          this.minDate = range.minDate;
        });
      }
    });
  }
}
